<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Hall Ticket Settings</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Assessment Type</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="assessmenttype"
                            :items="assessment_type_list" item-text="assessment" item-value="id" label="Assessment Type"
                            outlined persistent-hint hint="Please Select Assessment Type" />
                    </v-col>
                    <v-col cols="12" sm="2">
                        <p><v-icon color="error">*</v-icon>&nbsp;<b>Standard</b></p>

                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="standard_id" label="Standard" multiple outlined
                            persistent-hint hint="Please Select Standard" />
                    </v-col>
                    <v-col cols="12" sm="3">
                        <p><v-icon color="error">*</v-icon><b>Hall Ticket Display Date</b></p>
                        <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
                            transition="scale-transition" offset-y max-width="290px" min-width="290px">
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-bind="attrs" dense v-model="open_house_date"
                                    @blur="date = parseDate(open_house_date)" v-on="on" hint="From Date"
                                    prepend-icon="event" outlined rounded persistent-hint></v-text-field>
                            </template>
                            <v-date-picker v-model="house_date" no-title @input="menu2 = false"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row justify="center" dense>
                    <v-btn class="button" @click="save()" :loading="loader">Save</v-btn>
                </v-row>
            </v-card>
            <v-card class="box" v-if="open_house_list!=''">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Hall Ticket Settings</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-data-table :headers="headers" class="elevation-1 mytable" :items-per-page="-1" dense
                    :items="bookList1" @current-items="getFiltered">
                    <template v-slot:[`item.start_date`]="{ item }">
                        <!-- {{ item.hall_ticket_date_display }} -->
                        <v-avatar size="25" class="edit-avatar ">
                            <v-icon class="mr-2 edit-v-icon" @click="changeDate(item)" title="edit">edit</v-icon>
                        </v-avatar>
                    </template>
                    <!-- filters added here -->
                    <template v-slot:top class="pb-5">
                        <v-row dense justify="center" align="center">
                            <tr class="t-row">
                                <div>
                                    <th>
                                        <v-row>
                                            <span v-for="header in headers" :key="header.text">
                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                    <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small
                                                        rounded dense outlined color="#0F2027" :label="header.text"
                                                        multiple clearable :items="columnValueList(header.value)"
                                                        v-model="filters[header.value]"></v-autocomplete>
                                                </span>
                                            </span>
                                        </v-row>
                                    </th>
                                </div>
                            </tr>
                        </v-row>
                    </template>
                </v-data-table>
            </v-card>
            <v-dialog v-model="dialog" max-width="800px">
                <v-card>
                    <v-col cols="12" sm="12" md="12">
                        <v-card class="box">
                            <v-row justify="center" dense>
                                <v-col cols="12" sm="6" md="6">
                                    <p><b>Update Hall Ticket Date</b></p>
                                    <v-dialog ref="dialog" v-model="modal1" :return-value.sync="date_edit" persistent
                                        width="290px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="date_edit" rounded outlined dense
                                                prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                v-on="on"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="date_edit" scrollable>
                                            <v-spacer></v-spacer><v-btn text color="primary"
                                                @click="modal1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.dialog.save(date_edit)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row justify="center" dense>
                                <v-btn class="button" @click="update(item)" :loading="loader">Update</v-btn>
                                <v-btn class="button" @click="dialog = false">Close</v-btn>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-card>
            </v-dialog>
        </v-container>
    </div>
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            open_house_date: "",
            house_date: new Date().toISOString().substr(0, 10),
            date_edit_marksheet: "",
            marksheet_date: new Date().toISOString().substr(0, 10),
            // extraBreadcrumbItems: [
               

            // ],
            // breadcrumbClass: "breadcrumb-style1",
            delete_attach_load: false,
            loader: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            ay_list: [],
            ay: "",
            standard_list: [],
            standard: [],
            open_house_list: [],
            assessment_type_list: [],
            assessmenttype: "",
            assessment: null,
            title: "",
            date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            // date_edit_marksheet: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
            date_edit: "",
            menu1: false,
            menu12: false,
            modal1: false,
            modal2: false,
            edit_openhouse_id: "",
            menu: false,
            modal: false,
            menu2: false,
            checkbox: false,
            dialog: false,
            headers: [
                { text: "Sr. No.", value: "srno" },
                { text: "Academic Year", value: "academicyear" },
                { text: "Assessment Type", value: "assessmenttype_config" },
                { text: "Standard", value: "standard" },
                { text: "Hall Ticket Display Date", value: "hall_ticket_date_display" },
                { text: "Edit", value: "start_date" },
            ],
            filterArr: [],
            filters: {
                standard: [],
                assessmenttype: [],
                academicyear: [],
            },
        }),
        computed: {
            bookList1() {
                return this.open_house_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            formatDate(date) {
                if (!date) return null;
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            },
            parseDate(date) {
                if (!date) return null;
                const [month, day, year] = date.split("/");
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.open_house_list.map((d) => d[val]);
            },
            update(item) {
                const formData = {
                    openhouse_id: this.edit_openhouse_id,
                    date_edit: this.date_edit,
                };
                axios
                    .post("/Examination/updateHallTicketSetting", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Updated Successfully...");
                            this.open_house_list = res.data.open_house_list;
                            this.dialog = false;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                        this.dialog = false;
                    });
            },
            changeDate(item) {
                this.dialog = true;
                (this.date_edit = item.hall_ticket_date_display_edit), (this.edit_openhouse_id = item.id);
            },
            save() {
                this.loader = true;
                if (this.ay == "" || this.ay == null) {
                    this.showSnackbar("#b71c1c", "Please Select Academic Year");
                    return;
                }
                if (this.assessmenttype == "" || this.assessmenttype == null) {
                    this.showSnackbar("#b71c1c", "Please Select Assessment Type");
                    return;
                }
                if (this.standard == "" || this.standard == null) {
                    this.showSnackbar("#b71c1c", "Please Select Standard");
                    return;
                }
                if (this.open_house_date == "" || this.open_house_date == null) {
                    this.showSnackbar("#b71c1c", "Please Select Date");
                    return;
                }
                const formData = {
                    ay: this.ay,
                    standard: this.standard,
                    open_house_date: this.open_house_date,
                    assessmenttype: this.assessmenttype
                };
                axios
                    .post("/Examination/saveHallTicketSetting", formData)
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            this.showSnackbar("#4caf50", "Saved Successfully...");
                            this.open_house_list = res.data.open_house_list;
                        } else if (res.data.flag == "No") {
                            this.showSnackbar("#b71c1c", res.data.snackbar);
                        } else {
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.loader = false;
                    });
            },
            onLoad() {
                axios
                    .post("/Examination/hallTicketSettingHome")
                    .then((res) => {
                        if (res.data.flag == "Yes") {
                            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay), (this.standard_list = res.data.standard_list), (this.open_house_list = res.data.open_house_list);
                            this.assessment_type_list = res.data.assessment_type_list;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },

            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
            this.open_house_date = this.formatDate(this.house_date);
        },
        watch: {
            house_date(val) {
                this.open_house_date = this.formatDate(this.house_date);
            },
        },
    };
</script>
<style scoped>
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
